import { Divider, Form, Message } from '@mairistem/composants';
import React from 'react';
import UtilisateurError from '../../enums/UtilisateurError';
import type { UtilisateurCollectiviteToCreate } from '../../interfaces/utilisateurCollectivite';

interface UtilisateurForm {
	codeClient?: string;
	email?: string;
	login?: string;
	qualite?: string;
	nom?: string;
	prenom?: string;
	codePostal?: string;
	ville?: string;
	isAgentTeletransmetteur?: boolean;
	isAgentActe?: boolean;
	isSignataireParapheur?: boolean;
}

interface UtilisateurSelectedFormProps {
	user?: UtilisateurForm;
	onChange?: (user: Partial<UtilisateurCollectiviteToCreate>) => void;
	errors?: UtilisateurError[];
	isRequiredData?: boolean;
	isCreation?: boolean;
	handleChangeRoles?: (
		e: React.SyntheticEvent<HTMLElement>,
		{ name, checked }: { name: string; checked: boolean },
	) => void;
}

const UtilisateurSelectedForm = ({
	user,
	onChange,
	errors = [],
	isRequiredData = false,
	isCreation = false,
	handleChangeRoles,
}: UtilisateurSelectedFormProps) => {
	const handleCodePostalChange = (
		_e: React.SyntheticEvent<HTMLElement>,
		data: { value: string; name: string },
	) => {
		const numericValue = data.value.replace(/\D/g, '').slice(0, 5);
		if (onChange) {
			onChange({ ...user, [data.name]: numericValue });
		}
	};

	const handleChangeUser = (
		_e: React.SyntheticEvent<HTMLElement>,
		{ value, name }: { value: string; name: string },
	) => {
		if (onChange) {
			onChange({ ...user, [name]: value });
		}
	};

	return (
		<Form>
			<Form.Group widths="equal">
				<Form.Input
					label="Adresse email"
					required
					name="email"
					value={user?.email}
					onChange={handleChangeUser}
					error={
						errors.includes(UtilisateurError.EMAIL) ||
						errors.includes(UtilisateurError.EMAIL_FORMAT)
					}
				/>
				{!isCreation && (
					<Form.Input
						label="Fonction"
						name="qualite"
						value={user?.qualite}
						onChange={handleChangeUser}
						error={errors.includes(UtilisateurError.QUALITE)}
						required={isRequiredData}
					/>
				)}
			</Form.Group>
			{errors.includes(UtilisateurError.EMAIL_FORMAT) && (
				<Message error>Le format de l&apos;email est invalide.</Message>
			)}
			<Form.Group widths="equal">
				<Form.Input
					label="Nom"
					name="nom"
					required
					value={user?.nom}
					error={errors?.includes(UtilisateurError.NOM)}
					onChange={handleChangeUser}
				/>
				<Form.Input
					label="Prénom"
					required
					value={user?.prenom}
					error={errors?.includes(UtilisateurError.PRENOM)}
					name="prenom"
					onChange={handleChangeUser}
				/>
			</Form.Group>

			{!isCreation && (
				<Form.Group widths="equal">
					<Form.Input
						label="Code postal"
						name="codePostal"
						onChange={handleCodePostalChange}
						type="text"
						maxLength={5}
						value={user?.codePostal}
						error={errors.includes(UtilisateurError.CODE_POSTAL)}
						required={isRequiredData}
						placeholder="ex: 75001"
					/>
					<Form.Input
						label="Ville"
						name="ville"
						value={user?.ville}
						onChange={handleChangeUser}
						error={errors.includes(UtilisateurError.VILLE)}
						required={isRequiredData}
					/>
				</Form.Group>
			)}

			{isCreation && (
				<Form.Group>
					<Form.Checkbox
						label="Agent télétransmetteur"
						onClick={handleChangeRoles}
						name="isAgentTeletransmetteur"
						checked={user?.isAgentTeletransmetteur}
					/>
					<Form.Checkbox
						label="Agent acte"
						name="isAgentActe"
						onClick={handleChangeRoles}
						checked={user?.isAgentActe}
						disabled={user?.isAgentTeletransmetteur}
					/>
					<Form.Checkbox
						label="Signataire parapheur"
						onClick={handleChangeRoles}
						name="isSignataireParapheur"
						checked={user?.isSignataireParapheur}
					/>
				</Form.Group>
			)}
			{errors.includes(UtilisateurError.ROLE) && (
				<Message error>
					Veuillez sélectionner au moins une option parmi Agent
					télétransmetteur, Agent acte ou Signataire parapheur.
				</Message>
			)}

			{user?.isSignataireParapheur && (
				<>
					<Divider hidden />
					<Form.Group widths="equal">
						<Form.Input
							label="Code postal"
							name="codePostal"
							onChange={handleCodePostalChange}
							type="text"
							maxLength={5}
							required
							value={user?.codePostal}
							error={errors.includes(UtilisateurError.CODE_POSTAL)}
							placeholder="ex: 75001"
						/>
						<Form.Input
							label="Ville"
							name="ville"
							value={user?.ville}
							required
							placeholder="ex: Paris"
							onChange={handleChangeUser}
							error={errors.includes(UtilisateurError.VILLE)}
						/>
						<Form.Input
							label="Fonction"
							name="qualite"
							value={user?.qualite}
							onChange={handleChangeUser}
							required
							error={errors.includes(UtilisateurError.QUALITE)}
						/>
					</Form.Group>
				</>
			)}
		</Form>
	);
};

export default UtilisateurSelectedForm;
